module.exports = __webpack_public_path__ + "06_long_grey.7fb747bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/06_long_grey.png
// module id = rhG1
// module chunks = 0